import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import FooterCopyright from "../../components/footer/FooterCopyright";

const MainFooter = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu,
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <footer
      className={`footer-area ${
        backgroundColorClass ? backgroundColorClass : ""
      } ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      } ${extraFooterClass ? extraFooterClass : ""} ${
        spaceLeftClass ? spaceLeftClass : ""
      } ${spaceRightClass ? spaceRightClass : ""}`}
    >
      <div className={`${containerClass ? containerClass : "container"}`}>
        <div className="row">
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-5" : "col-lg-3 col-sm-5"
            }`}
          >
            {/* footer copyright */}
            <FooterCopyright
              footerLogo="/assets/img/logo/nsi-logo-min.png"
              spaceBottomClass="mb-30"
            />
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-5" : "col-lg-3 col-sm-5"
            }`}
          >
            <div className="footer-widget">
              <div className="footer-title">{/* <h3>ABOUT US</h3> */}</div>
              <div className="footer-list">
                <table>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan={4}
                        align="center"
                        style={{ borderBottom: "2px solid black" }}
                      >
                        Head Office
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <i className="pe-7s-map-marker"></i>
                      </td>
                      <td>
                        &nbsp;Jalan Cilengkrang 1 No 46 (atas), Cisurupan, Kec
                        Cibiru, Kota Bandung, Jawa Barat 40615
                      </td>
                      <td valign="top">
                        <i className="pe-7s-call"></i>
                      </td>
                      <td valign="top">&nbsp;(022)87529350</td>
                    </tr>
                    <tr>
                      <td colSpan={4}></td>
                    </tr>
                    <tr>
                      <td colSpan={4}></td>
                    </tr>
                    <tr>
                      <td
                        colSpan={4}
                        align="center"
                        style={{ borderBottom: "2px solid black" }}
                      >
                        Marketing Office
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <i className="pe-7s-map-marker"></i>
                      </td>
                      <td>
                        &nbsp;Metro Trade Center Blok E / 11 Jl. Soekarno Hatta
                        No.590, Sekejati, Buahbatu, Bandung City, West Java
                        40286
                      </td>
                      <td valign="top">
                        <i className="pe-7s-phone"></i>
                      </td>
                      <td valign="top">
                        &nbsp;081224422655
                        <br />
                        &nbsp;082111406123
                        <br />
                        &nbsp;085217008877
                        <br />
                        &nbsp;085186671680
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" style={{ paddingTop: 10 }}>
                        <i className="pe-7s-mail"></i>
                      </td>
                      <td style={{ paddingTop: 10 }} colSpan="3">
                        &nbsp;marketing@nagatech.id
                      </td>
                    </tr>
                    {/* <tr>
                      <td valign="top" style={{ paddingTop: 10 }}>
                        <i className="pe-7s-call"></i>
                      </td>
                      <td style={{ paddingTop: 10 }}>&nbsp;(022)63759821</td>
                    </tr> */}
                    {/* <tr>
                      <td valign="top" style={{ paddingTop: 10 }}>
                        <i className="pe-7s-phone"></i>
                      </td>
                      <td style={{ paddingTop: 10 }}>
                        &nbsp;081224422655
                        <br />
                        &nbsp;081227777484
                        <br />
                        &nbsp;082111406123
                      </td>
                    </tr> */}
                  </tbody>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-5" : "col-lg-3 col-sm-5"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">{/* <h3>USEFUL LINKS</h3> */}</div>
              <div className="footer-list">
                <ul>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product"}>
                      Product
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/hardware"}>
                      Hardware
                    </Link>
                  </li>
                  <li>
                    <a href="https://www.boxperhiasan.com/#/">
                      Kotak Perhiasan
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-5" : "col-lg-3 col-sm-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-115"
                  : "footer-widget mb-30 ml-45"
              }`}
            >
              <div className="footer-title">
                <p>Informasi Perusahaan</p>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <a href={process.env.PUBLIC_URL + "/about-us"}>About us</a>
                  </li>
                  <li>
                    <a href={process.env.PUBLIC_URL + "/contact"}>Contact us</a>
                  </li>
                </ul>
                <div className="footer-title" style={{ marginTop: 20 }}>
                  <p>Tetap terhubung dengan kami</p>
                </div>
                <div className="footer-list">
                  <a
                    href="https://www.instagram.com/nagatechsi/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fa fa-instagram fa-3x"
                      aria-hidden="true"
                      style={{ color: "#F5A52C" }}
                    ></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCH2JbmEkGJzaKwlNNVCiwYA/featured"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fa fa-youtube-play fa-3x"
                      aria-hidden="true"
                      style={{ marginLeft: 15, color: "#F5A52C" }}
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

MainFooter.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
};

export default MainFooter;
